const styles = (theme) => ({
  avatar: {
    width: '128px',
    height: '128px',
    [theme.breakpoints.down('md')]: {
      width: '64px',
      height: '64px',
    },
  },
  avatarContainer: {
    width: '100%',
  },
});

export default styles;
